import React from 'react'
import { LocaleProvider } from '@elegantstack/gatsby-blog-core/src/context/LocaleContext'
import locales from './src/locales'

export const wrapPageElement = ({ element, props }) => {
  const { pageContext } = props
  const locale = pageContext.locale || 'en'
  const defaultLocale = pageContext.defaultLocale || 'en'
  const configuredLocales = pageContext.locales || []
  const translations = pageContext.translations || {}
  const fallbackTranslations = pageContext.fallbackTranslations || {}
  const localeConfig = configuredLocales.find(l => l.code === locale) || {
    dir: 'ltr'
  }
  const translationStrings = locales[locale] || locales['en'] || {}

  return (
    <LocaleProvider
      locale={locale}
      dir={localeConfig.dir}
      defaultLocale={defaultLocale}
      locales={configuredLocales}
      translations={translations}
      fallbackTranslations={fallbackTranslations}
      translationStrings={translationStrings}
    >
      {element}
    </LocaleProvider>
  )
}
